import React from "react";
import ImageWithSkeleton from "./ImageWithSkeleton";

export default function OneProject({
  name,
  content,
  photoFolder,
  photoAmount,
}) {
  const makeArray = () => {
    return Array.from({ length: photoAmount }, (_, index) => index + 1);
  };

  return (
    <div className="mb-24">
      <div className="mb-8 text-center max-w-3xl mx-auto">
        <h2 className="text-3xl md:text-4xl font-bold text-vinefin-900 mb-4">
          {name}
        </h2>
        <p className="text-lg text-gray-600 leading-relaxed">{content}</p>
      </div>

      <div className="grid grid-cols-1 sm:grid-cols-2 md:grid-cols-3 lg:grid-cols-4 gap-4">
        {makeArray().map((el) => (
          <div
            key={el}
            className="aspect-square group overflow-hidden rounded-2xl shadow-md hover:shadow-xl transition-all duration-300"
          >
            <ImageWithSkeleton
              src={`/${photoFolder}/${el}.jpg`}
              alt={`${name} ${el}`}
              className="w-full h-full group-hover:scale-110 transition-transform duration-500"
            />
          </div>
        ))}
      </div>
    </div>
  );
}
